// Module
var code = "<div class=\"ui checkbox\"> <input type=\"checkbox\" ng-model=\"news.show\"> <label>{{ (text ? text : 'edit.general.settings_showOnNews') | translate }} {{ news.catName.length ? news.catName : 'explore.general.categories_featured' | translate }} </label> </div> ";
// Exports
module.exports = code;